module.exports = __webpack_public_path__ + "img/iconG.17692221.jpg";